/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class CommonAlert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      testUsedate: null,
      style: null
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) });
  }

  render() {
    return (
      <div className="layer-pop" id="appcomp-pop" style={this.state.style} ref={ref => this.layer = ref}>	
        <div className="bg"></div>
        <div className="app-comp-pop">
          <div className="acpop-cont">
            <p className="t-logo"><span className="blind">TOZ StudyCenter</span></p>
            {this.props.msgObj.extendMsg ? <div dangerouslySetInnerHTML={{ __html: this.props.msgObj.extendMsg}}></div> : ''}
            <p className="btxt" dangerouslySetInnerHTML={{ __html: this.props.msgObj.msg}}></p>
            <p className={`btns ${this.props.buttonLabel.length === 1 ? 'center' : ''}`}>
              {this.props.buttonLabel.map((obj, index) => <a href={null} key={index} className={`btn ${index === 0 ? 'fl' : 'fr'} layer-pop-close${(this.props.buttonLabel.length === 1 && index === 0) || (this.props.buttonLabel.length === 2 && index === 1) ? ' active' : ''}`} data-type={obj.type} onClick={this.props.onClick.bind(this, obj)}>{obj.label}</a>)}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default CommonAlert;